import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Container, Row, Col, Button } from 'react-bootstrap';
import RegBreadcrumb from '../components/RegBreadcrumb';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import { authService } from '../functions/authenticate';
import { accountService } from '../functions/registerApi';

const GroupRegistrationDone = ({ userID, setUserID, userName, setUserName, login, setLogin, authToken, setAuthToken }) => {

  const navigate = useNavigate();
  const { groupCode } = useParams();
  const [company, setCompany] = useState('');
  const [contactName, setContactName] = useState('');
  const [paymentID, setPaymentID] = useState('');
  const [quota,setQuota] = useState(0);
  const [registered, setRegistered] = useState(0);

  const handlePrint = (e) => {
    e.preventDefault();
    window.open(process.env.REACT_APP_PUBLIC_URL + `/payment/download_group_chit.php?paymentID=${groupCode}`);
  }

  const handleRedirect = (e) => {
    e.preventDefault();
    navigate('/Register');
  }

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if(token==='' || token===null)
    {
      navigate('/Login');
    }
    else
    {
      // console.log(token);
      authService.validateAuthToken(token)
        .then((response) => {
          // console.log(response);
          if(!response.status)
          {
            navigate('/Login');
          }
          else if(!login)
          {
            let data = response.body.user;
            setUserID(data.individualID);
            localStorage.setItem('userID', data.individualID);
            // console.log(localStorage.getItem('userID'));
            setLogin(true);

            setUserName(data.firstname + ' ' + data.lastname);
            localStorage.setItem('userName', data.firstname + ' ' + data.lastname);
            
            setAuthToken(response.body.token);
            localStorage.setItem('authToken', response.body.token);
          }
        })
        .catch((error) => {
          console.log(error);
          // navigate('/Login');
        });
    }
  }, [authToken]);

  useEffect(() => {
    if(groupCode != null && groupCode != "") {
      accountService.getGroupRegistration(groupCode)
        .then((response) => {

          // console.log(response);

          if(response.status) {
            let data = response.body;

            setCompany(data.company);
            setContactName(data.contactPerson);
            setQuota(data.quota);
            setRegistered(data.registered);

            localStorage.setItem('promoCode', '');
          } else {
            alert("Invalid group code");
            navigate('/Register');
          }

        })
        .catch((error) => {
          console.log(error);
          // navigate('/Login');
        });
    }
  }, [groupCode]);

  return (
    <Container fluid="lg" className='wrapper'>

      <h1 className="title">Registration Status</h1>
      {/* <RegBreadcrumb page={4} /> */}

      <Row className="payment-loading-box">

        <h5>Dear {userName},</h5>

        <h3 className='mt-2 text-success'>Registration went through successfully.</h3>

        <Row>

          <Col md={12} sm={12} className="mt-3">
            <h4>Group Code: <strong>{groupCode}</strong></h4>
            <h4>Company / Organisation: <strong>{company}</strong></h4>
            <h4>Person In Charge: <strong>{contactName}</strong></h4>
            <h4>Total Runner Registered: <strong>{registered}</strong></h4>
          </Col>

          <Col md={12} sm={12} className="mt-2">
            <p className="text-danger">
              Note: Thank you for your registration.
              Please take note this is acknowledge that we have received your registration confirmation.
              However, this acknowledgement does not serve as a confirmation of your registration.
            </p>
            <p className="text-danger">
              We will promptly process and issue an invoice to person in charge to proceed with payment.
              Upon receiving payment of the registration fee, we shall confirm this registration, and an email
              confirmation chit will be issued to the person in charge.
            </p>
            <a className="btn btn-secondary mb-5" onClick={handleRedirect} >
              Back to Home
            </a>
          </Col>

        </Row>

      </Row>

    </Container>
  );

}

export default GroupRegistrationDone;